// apps/client/src/ui/hud/ActionPad.tsx — bottom-right: A (leaf-700, labelled by the prompt verb), B (cancel; hold to run) and
// Tool (from M1, when pockets exist). Sizes follow DESIGN.md "HUD (landscape phone)": A 9.4cqw, B and Tool 7cqw.
import { getGame, useCommands } from '../../game/instance';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { RoundButton } from '../kit';
import { hasScreen } from '../router';
import { Hook, Run } from './Icons';

const CSS = `
.hud-pad { position: absolute; right: calc(var(--hud-inset) + env(safe-area-inset-right)); bottom: calc(var(--hud-inset) + env(safe-area-inset-bottom));
  display: grid; grid-template-columns: auto auto; grid-template-rows: auto auto; column-gap: 1.8cqw; row-gap: 1.4cqw; align-items: end; }
.hud-pad .round-btn { width: clamp(48px, 7cqw, 96px); height: clamp(48px, 7cqw, 96px); }
.hud-pad .round-btn svg { width: 46%; height: 46%; }
.hud-pad .pad-tool { grid-column: 1; grid-row: 1; justify-self: end; }
.hud-pad .pad-b { grid-column: 1; grid-row: 2; }
.hud-pad .pad-a { grid-column: 2; grid-row: 1 / span 2; align-self: end; margin-bottom: 2.4cqw; }
.hud-pad .pad-a .round-btn { width: clamp(64px, 9.4cqw, 128px); height: clamp(64px, 9.4cqw, 128px); font-size: clamp(15px, 2.1cqw, 26px);
  letter-spacing: .01em; line-height: 1.05; padding: 0 .5em; text-align: center; }
`;
let styled = false;
function injectStyle(): void {
  if (styled || typeof document === 'undefined') return;
  styled = true;
  const el = document.createElement('style');
  el.dataset.owner = 'hud-pad';
  el.textContent = CSS;
  document.head.appendChild(el);
}

export function ActionPad() {
  injectStyle();
  const t = useT();
  const cmd = useCommands();
  const prompt = useGame((s) => s.prompt);
  const label = prompt ? t(prompt.verb) : t('hud.a');   // contract change 20: 'A' when nothing offers a verb
  /** Holding B runs; the release is caught on the window, so sliding the thumb off the button still stops running. */
  const holdRun = () => {
    getGame().input?.setHeld('B', true);
    const release = () => { getGame().input?.setHeld('B', false); removeEventListener('pointerup', release); removeEventListener('pointercancel', release); };
    addEventListener('pointerup', release);
    addEventListener('pointercancel', release);
  };
  return (
    <div className="hud-pad">
      {hasScreen('pockets') && <div className="pad-tool"><RoundButton label={t('hud.tool')} onClick={() => cmd.press('tool')}><Hook /></RoundButton></div>}
      <div className="pad-b">
        <RoundButton label={t('hud.run')} onPointerDown={holdRun} onPointerUp={() => cmd.press('B')}><Run /></RoundButton>
      </div>
      <div className="pad-a"><RoundButton label={label} green onClick={() => cmd.press('A')}>{label}</RoundButton></div>
    </div>
  );
}
